import * as React from "react";
import RavenService from "../../services/Logging/RavenService";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

interface IProps {
  renderError?: () => React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

interface IState {
  caughtError: boolean;
}

export default class ErrorCatcher extends React.Component<IProps, IState> {
  public static defaultProps: IProps = {
    renderError: () => <ErrorMessage />,
    onError: (error: Error, errorInfo: React.ErrorInfo) => {
      console.error(error);
      RavenService.captureException(error, errorInfo);
    }
  };

  public state: IState = {
    caughtError: false
  };

  public render() {
    const { caughtError } = this.state;
    const { renderError } = this.props;
    if (caughtError) {
      return renderError && renderError();
    } else {
      return this.props.children;
    }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { onError } = this.props;
    if (onError) {
      onError(error, errorInfo);
    }
    this.setState({ caughtError: true });
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorCatcher/ErrorCatcher.tsx